// extracted by mini-css-extract-plugin
module.exports = {"myStepper":"Stepper_myStepper__lYZ_8","myStepperDark":"Stepper_myStepperDark__2xOUX"};